import type { Dayjs } from "dayjs";
import { useCallback, useState } from "react";
import { Severity } from "type";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import downloadSystemUsageApi from "../api/downloadSystemUsageApi";
import type { BOErrorParams } from "../types";
import downloadBOErrorApi from "../api/downloadBOErrorApi";
import { INVALID_DATE } from "../constants";

/**
 * Custom hooks to use system usage as CSV.
 * @param showAlert アラート表示
 */
export default function useBOErrorDownload(showAlert: (msg: string, severity?: Severity) => void) {
  const [dateFrom, setDateFrom] = useState<Dayjs | null>(dayjs().startOf("month"));
  const [dateTo, setDateTo] = useState<Dayjs | null>(dayjs());
  const [storeCd, setStoreCd] = useState<string>("");

  // const [storeName, setStoreName] = useState("");
  // const [startDate, setStartDate] = useState<Dayjs | null>(null);
  // const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDownload = useCallback(async () => {
    if (!dateFrom || !dateTo) {
      showAlert("開始日と終了日を指定してください", "error");
      return;
    }
    if (dateFrom.format("YYYY-MM-DD HH:mm") === INVALID_DATE || dateTo.format("YYYY-MM-DD HH:mm") === INVALID_DATE) {
      showAlert("開始日と終了日を正しく指定してください", "error");
      return;
    }

    setIsLoading(true);
    try {
      // const safeTarget = target ?? 1;
      const params: BOErrorParams = {
        dateFrom: dateFrom.format("YYYY-MM-DD HH:mm"),
        dateTo: dateTo.format("YYYY-MM-DD HH:mm"),
        // storeCd,
      };
      await downloadBOErrorApi(params, showAlert);

      // const blob = await downloadSystemUsageApi(params);
      // const url = window.URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = `system-usage_${params.startDate}_${params.endDate}.csv`;
      // a.click();
      // window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      showAlert("CSVのダウンロードに失敗しました", "error");
    } finally {
      setIsLoading(false);
    }
  }, [dateFrom, dateTo, storeCd]);

  return {
    // storeName,
    // setStoreName,
    // startDate,
    // setStartDate,
    // endDate,
    // setEndDate,
    // handleDownload,
    // isLoading,

    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    storeCd,
    setStoreCd,
    handleDownload,
    isLoading,
  };
}
